import script from "./KanbanRoutesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./KanbanRoutesTable.vue?vue&type=script&setup=true&lang=js"

import "./KanbanRoutesTable.vue?vue&type=style&index=0&id=340b6d4e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-340b6d4e"]])

export default __exports__